
namespace RioERP.Common {

    @Serenity.Decorators.registerClass()
    export class SMSDialog extends Serenity.EntityDialog<SMSRow, any> {
        protected getFormKey() { return SMSForm.formKey; }
        protected getIdProperty() { return SMSRow.idProperty; }
        protected getLocalTextPrefix() { return SMSRow.localTextPrefix; }
        protected getNameProperty() { return SMSRow.nameProperty; }
        protected getService() { return SMSService.baseUrl; }
        protected getDeletePermission() { return SMSRow.deletePermission; }
        protected getInsertPermission() { return SMSRow.insertPermission; }
        protected getUpdatePermission() { return SMSRow.updatePermission; }

        protected form = new SMSForm(this.idPrefix);

    }
}